import request from './request.js'

/**
 * 生成分享链接（需登录）
 * @param showId 为空表示分享整个列表；传值表示分享单条明细
 * @param customerName 客户名称（必填）
 * @returns {Promise<{shareCode, link}>}
 */
export const createShare = (showId, customerName) => {
  return request({
    url: '/share/create',
    method: 'post',
    params: { showId: showId || '', customerName }
  })
}

/**
 * 客户访问分享页（公开）
 */
export const getShare = (code) => {
  return request({
    url: `/share/${code}`,
    method: 'get'
  })
}

/**
 * 浏览埋点上报（公开）
 * @param data {shareCode, showId, deviceId, event, duration}
 */
export const reportBrowse = (data) => {
  return request({
    url: '/share/browse/report',
    method: 'post',
    params: data
  })
}

/**
 * 某明细的浏览记录列表（需登录，维护页用）
 */
export const getBrowseByShow = (showId) => {
  return request({
    url: '/share/browse/byShow',
    method: 'get',
    params: { showId }
  })
}

/**
 * 客户浏览列表（仅管理员）
 */
export const getCustomers = () => {
  return request({
    url: '/share/customers',
    method: 'get'
  })
}